"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionSort = void 0;
exports.CollectionSort = {
    CreatedAt: 'created_at',
    UpdatedAt: 'userModifiedDate',
    Title: 'title',
};
